export default {
  confirm: "Confirm",
  adjustAgain: "Adjust Again"
};
